import apiClient from './index';

export type MeterRadioHead = {
  id: string;
  building_id?: string | null;
  serial_number?: string | null;
  dev_eui: string;
  manufacturer?: string | null;
  model?: string | null;
  notes?: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by_user_id?: string | null;
};

export type MeterRadioHeadBinding = {
  id: string;
  device_id: string;
  head_id: string;
  baseline_meter_value?: number | null;
  active_from: string;
  active_to?: string | null;
  close_reason?: string | null;
  notes?: string | null;
  created_at: string;
  created_by_user_id?: string | null;
  head?: MeterRadioHead | null;
};

export type DeviceHeadState = {
  device_id: string;
  system_type?: string | null;
  has_pulse_connection: boolean;
  active_binding?: MeterRadioHeadBinding | null;
  history: MeterRadioHeadBinding[];
};

export type MeterRadioHeadCreate = {
  serial_number?: string | null;
  dev_eui: string;
  manufacturer?: string | null;
  model?: string | null;
  building_id?: string | null;
  notes?: string | null;
};

export const meterRadioHeadsApi = {
  async getDeviceState(deviceId: string): Promise<DeviceHeadState> {
    const res = await apiClient.get<DeviceHeadState>(`/meter-radio-heads/devices/${deviceId}`);
    return res.data;
  },

  async bind(deviceId: string, payload: {
    head_id?: string | null;
    head?: MeterRadioHeadCreate | null;
    baseline_meter_value?: number | null;
    notes?: string | null;
  }): Promise<MeterRadioHeadBinding> {
    const res = await apiClient.post<MeterRadioHeadBinding>(
      `/meter-radio-heads/devices/${deviceId}/bind`,
      payload
    );
    return res.data;
  },

  async unbind(deviceId: string, closeReason?: string): Promise<MeterRadioHeadBinding> {
    const res = await apiClient.post<MeterRadioHeadBinding>(
      `/meter-radio-heads/devices/${deviceId}/unbind`,
      { close_reason: closeReason || 'unbound' }
    );
    return res.data;
  },
};
